import React from "react";
import { Box } from "@mui/material";

const Curve = ({ fillColor = "#FFD700" }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        overflow: "hidden",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1500 70"
        preserveAspectRatio="none"
        style={{ width: "100%", height: "100%", zIndex: -2 }}
      >
        <path
          fill={fillColor}
          d="M0,71 Q500,65 800,20 Q1200,-30 1500,71 L1500,0 L0,0 Z"
        ></path>
      </svg>
    </Box>
  );
};

export default Curve;
